module.exports = __webpack_public_path__ + "img/bit2.b9ce35c5.png";